// Fonction pour déterminer le style de cellule selon les états
export const getCellStyle = (states) => {
  if (!states || states.size === 0) {
    return {
      type: 'single',
      className: 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200',
      icon: '--'
    };
  }

  const hasAnime = states.has('Animé') && states.get('Animé') > 0;
  const hasAnnule = states.has('Annulé') && states.get('Annulé') > 0;
  const hasEnAttente = states.has('En attente') && states.get('En attente') > 0;
  const hasAutre = Array.from(states.keys()).some(state =>
    state !== 'Animé' && state !== 'Annulé' && state !== 'En attente' && states.get(state) > 0
  );

  // État mixte Animé + Annulé
  if (hasAnime && hasAnnule) {
    return {
      type: 'mixed',
      className: 'diagonal-green-red text-gray-900 dark:text-white',
      icon: '✓✗'
    };
  }

  // État mixte Animé + Autre (incluant En attente)
  if (hasAnime && (hasAutre || hasEnAttente) && !hasAnnule) {
    return {
      type: 'mixed',
      className: 'diagonal-green-gray text-gray-900 dark:text-white',
      icon: '✓--'
    };
  }

  // État mixte Annulé + Autre (incluant En attente)
  if (hasAnnule && (hasAutre || hasEnAttente) && !hasAnime) {
    return {
      type: 'mixed',
      className: 'diagonal-red-gray text-gray-900 dark:text-white',
      icon: '✗--'
    };
  }

  // États simples
  if (hasAnime && !hasAnnule && !hasAutre && !hasEnAttente) {
    return {
      type: 'single',
      className: 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200',
      icon: '✓'
    };
  }

  if (hasAnnule && !hasAnime && !hasAutre && !hasEnAttente) {
    return {
      type: 'single',
      className: 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200',
      icon: '✗'
    };
  }

  if (hasEnAttente && !hasAnime && !hasAnnule && !hasAutre) {
    return {
      type: 'single',
      className: 'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200',
      icon: '⏳'
    };
  }

  // Autre seul
  return {
    type: 'single',
    className: 'bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200',
    icon: '--'
  };
};
